import { useLingui } from '@lingui/react';
import { Chip } from '@pocketlaw/tetris';
export function UserRoleChip(props) {
    const { userRoleName } = props;
    const { i18n } = useLingui();
    // eslint-disable-next-line no-underscore-dangle
    const _i18n = i18n;
    return <Chip label={_i18n._(userRoleName)} variant="outline" appearance="secondary"/>;
}
